import { useCallback } from 'react';
import { atom, useAtom } from 'jotai';

export type SeedPost = {
  id: string;
  posterUrl: string;
  sourceUrl: string;
  content: string;
  aiMatchedFeatures: string[];
};
const MAX_SELECTED_POSTS = 6;
const seedPostsAtom = atom<Array<SeedPost>>([]);

export const useSeedPostStore = () => {
  const [seedPosts, setSeedPosts] = useAtom(seedPostsAtom);

  const toggleSeedPost = (post: SeedPost) => {
    const exists = seedPosts.some((item) => item.id === post.id);

    if (exists) {
      setSeedPosts((prev) => prev.filter((item) => item.id !== post.id));
      return { ok: true } as const;
    }

    if (seedPosts.length >= MAX_SELECTED_POSTS) {
      return { ok: false, reason: 'limit' } as const;
    }

    setSeedPosts((prev) => [...prev, post]);
    return { ok: true } as const;
  };

  const clearSeedPosts = useCallback(() => {
    setSeedPosts((prev) => (prev.length === 0 ? prev : []));
  }, [setSeedPosts]);

  const replaceSeedPosts = (posts: SeedPost[]) => {
    setSeedPosts(posts.slice(0, MAX_SELECTED_POSTS));
  };

  const removeSeedPost = (postId: string) => {
    setSeedPosts((prev) => prev.filter((item) => item.id !== postId));
  };

  const getSeedPostOrder = (postId: string) => {
    const index = seedPosts.findIndex((item) => item.id === postId);
    return index === -1 ? null : index + 1;
  };

  return {
    seedPosts,
    maxSelectedPosts: MAX_SELECTED_POSTS,
    getSeedPostOrder,
    toggleSeedPost,
    clearSeedPosts,
    replaceSeedPosts,
    removeSeedPost,
  };
};
